import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { meGQL } from "@onmo/graphql/graphql";
import { find } from "lodash-es";
import { ActiveIframe } from "../../components/common/GameFeed/ActiveIframe";
import { RewardScreen } from "../../components/common/RewardScreen";
import { useAppDispatch, useAppSelector } from "../../components/hooks";
import { useWalletConfig } from "../../hooks/useWalletConfig";
import { getWalletBalance } from "../../constants/wallet";
import { PageRoutes } from "../../constants/historyGaming";
import { useStyles } from "./PlayIframe.style";
import { serviceLinkMap } from "../../hooks/useDirectoryData";
import { setIsShowService } from "../../store/slices/popup";
import { useFeaturedCards } from "../../hooks/useFeaturedCards";
import { HomepageMd } from "../../models/homepage";
import { FEATURES } from "../../types/theme";

export const PlayIframe = () => {
  const classes = useStyles();
  const dispatch = useAppDispatch();
  const { theme } = useAppSelector((state) => state.theme);
  const { data: dataMe, refetch } = useQuery(meGQL);
  const { walletConfig } = useWalletConfig();
  const baseCoinType = walletConfig.primaryCurrency.base;
  const [activeIframe, setActiveIframe] = useState("");
  const [rewardAmount, setRewardAmount] = useState(0);
  const oldGzCoinRef = useRef<number | null>(null);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const feedId = params.get("feedId");
  const category = params.get("category");
  const homeFeed = useFeaturedCards();
  const hideRewardPage =
    theme?.hideFeature?.includes(FEATURES.rewardPage) || false;

  const navigate = useNavigate();

  const handleCloseIframe = async () => {
    setActiveIframe("");
    if (hideRewardPage) {
      navigate(PageRoutes.HomePage, { replace: true });
      dispatch(setIsShowService({ isShowService: false }));
      return;
    }
    const userUpdate = await refetch();
    if (userUpdate?.data?.me) {
      const oldGzCoin = oldGzCoinRef.current ?? 0;
      const newGzCoin = getWalletBalance(userUpdate?.data?.me?.coinWallets ?? [], baseCoinType);
      if (oldGzCoin !== newGzCoin) {
        setRewardAmount(newGzCoin - oldGzCoin);
      } else {
        navigate(PageRoutes.HomePage, { replace: true });
        dispatch(setIsShowService({ isShowService: false }));
      }
    }
  };

  useEffect(() => {
    if (category) return;
    const gameFeed = find(homeFeed, { id: feedId });
    if (!gameFeed) return;
    setActiveIframe(HomepageMd.getLink(gameFeed));
  }, [feedId, homeFeed]);

  useEffect(() => {
    if (feedId || !category) return;
    const categoryLink = serviceLinkMap[category];
    if (!categoryLink) return;
    setActiveIframe(categoryLink);
  }, [category]);

  useEffect(() => {
    if (oldGzCoinRef.current === null && dataMe?.me?.coinWallets) {
      oldGzCoinRef.current = getWalletBalance(dataMe.me.coinWallets, baseCoinType);
    }
  }, [dataMe?.me?.coinWallets]);

  return (
    <div>
      {activeIframe && (
        <ActiveIframe
          iframeUrl={activeIframe}
          onCloseIframe={handleCloseIframe}
          feedId={feedId ?? ""}
        />
      )}
      {!hideRewardPage && rewardAmount !== 0 && (
        <RewardScreen
          className={classes.endScreen}
          rewardAmount={rewardAmount}
        />
      )}
    </div>
  );
};
